// 2026-09-22：安全通知和公众号绑定只使用当前认证身份，不接受客户或操作员ID。
import request from '@/utils/request'
import {captureOrderIdentity} from '@/utils/orderContext'
export default {
  list:(beforeId?:string,unreadOnly=false)=>request({url:'customer/securityNotifications',method:'GET',quietNotification:true,params:{...(beforeId?{beforeId}:{}),...(unreadOnly?{unreadOnly:true}:{})}} as any),
  detail:(id:string)=>request({url:'customer/securityNotifications/'+encodeURIComponent(id),method:'GET',quietNotification:true} as any),
  read:(id:string)=>request({url:'customer/securityNotifications/read',method:'POST',quietNotification:true,data:{id},orderSubmissionIdentity:captureOrderIdentity()} as any),
  readAll:(maxId:string)=>request({url:'customer/securityNotifications/readAll',method:'POST',quietNotification:true,data:{maxId},orderSubmissionIdentity:captureOrderIdentity()} as any),
  binding:()=>request({url:'customer/loginSecurityBinding',method:'GET'}),
  createBinding:()=>request({url:'customer/loginSecurityBinding',method:'POST'})
}
